<template>
  <div class="contact-info-container">
    <div class="contact-card">
      <div class="contact-header">
        <!-- <img src="/sy-11.png" alt="上海超导" class="logo"> -->
        <div class="title"> {{ t('home.contactinfo.title') }}</div>
        
      </div>
       <div class="wechat-section">
        
          <div class="qrcode-container">
            <div class="qrcode-item">
              <img src="/images/wx/上海超导-服务号二维码20250327.jpg" alt="服务号" class="qrcode-img">
              <div class="qrcode-label">{{ t('home.contactinfo.serviceAccount') }}</div>
            </div>
            <div class="qrcode-item">
              <img src="/images/wx/上海超导SST-订阅号二维码20250327.jpg" alt="订阅号" class="qrcode-img">
              <div class="qrcode-label">{{ t('home.contactinfo.subscriptionAccount') }}</div>
            </div>
          </div>
        </div>
      <div class="contact-content">
        <div class="contact-item">
          <i class="el-icon-location"></i>
          <span>{{ t('home.contactinfo.address') }}</span>
        </div>
        <div class="contact-item">
          <i class="el-icon-phone"></i>
          <span>{{ t('home.contactinfo.phone') }}</span>
        </div>
        <div class="contact-item">
          <i class="el-icon-message"></i>
          <span>{{ t('home.contactinfo.email') }}</span>
        </div>
        <div class="email-list">
          <div class="email-item">{{ t('home.contactinfo.sales') }}</div>
          <div class="email-item">{{ t('home.contactinfo.hr') }}</div>
          <div class="email-item">{{ t('home.contactinfo.inquiry') }}</div>
          <div class="email-item">{{ t('home.contactinfo.inspection') }}</div>
        </div>
        
        <!-- 微信二维码区域 -->
       
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped lang="scss">
.contact-info-container {
  position: absolute;
  top: 80px;
  left: 30px;
  z-index: 20;
  max-width: 220px;
}

.contact-card {
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px) saturate(180%);
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    transform: translateY(-5px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    
    .contact-content {
      max-height: 500px;
      opacity: 1;
      transform: translateY(0);
      padding: 15px 20px;
    }
  }
}

.contact-header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  
  .logo {
    width: 80px;
    height: auto;
    margin-right: 15px;
  }
  
  .title {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }
}

.contact-content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: all 0.4s ease;
  transform: translateY(-10px);
  padding: 0 20px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  color: #333;
  
  i {
    margin-right: 10px;
    margin-top: 3px;
  }
  
  span {
    font-size: 14px;
    line-height: 1.5;
  }
}

.email-list {
  margin-left: 24px;
  
  .email-item {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.5;
  }
}

/* 微信二维码样式 */
.wechat-section {

}

.wechat-title {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
}

.qrcode-container {
  // display: flex;
  justify-content: space-around;
  margin-top: 5px;
}

.qrcode-item {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.qrcode-img {
  width: 58%;
  height: 58%;
  border-radius: 4px;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.qrcode-label {
  color: #fff;
  font-size: 12px;
  margin-top: 5px;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .contact-info-container {
    bottom: 20px;
    left: 20px;
    max-width: calc(100% - 40px);
  }
  
  .contact-header {
    padding: 12px 15px;
    
    .logo {
      width: 60px;
    }
    
    .title {
      font-size: 16px;
    }
  }
  
  .contact-card:hover .contact-content {
    padding: 12px 15px;
  }
  
  .contact-item span,
  .email-item {
    font-size: 13px;
  }
  
  .qrcode-img {
    width: 70px;
    height: 70px;
  }
}

@media screen and (max-width: 576px) {
  .contact-info-container {
    bottom: 15px;
    left: 15px;
  }
  
  .contact-header {
    padding: 10px 12px;
    
    .logo {
      width: 50px;
    }
    
    .title {
      font-size: 15px;
    }
  }
  
  .contact-card:hover .contact-content {
    padding: 10px 12px;
  }
  
  .contact-item span,
  .email-item {
    font-size: 12px;
  }
  
  .wechat-section {
    margin-top: 10px;
    padding-top: 10px;
  }
  
  .qrcode-img {
    width: 60px;
    height: 60px;
  }
  
  .qrcode-label {
    font-size: 11px;
  }
}
</style> 